// FindRestaurantsButton — Presentational "Find Restaurants" call-to-action.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// icon, text, and the onMouseOver/onMouseOut hover handlers are identical to
// the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { Search } from 'lucide-react';
import { primaryBlue, blueHover, blueOut } from './styles';

export const FindRestaurantsButton = React.memo(function FindRestaurantsButton({ onClick }) {
  return (
    <div style={{ textAlign: 'center', padding: '32px 16px' }}>
      <button
        onClick={onClick}
        style={{
          padding: '14px 28px',
          fontSize: '16px',
          fontWeight: '600',
          color: 'white',
          backgroundColor: primaryBlue,
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          transition: 'background-color 0.2s',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
        onMouseOver={blueHover}
        onMouseOut={blueOut}
      >
        <Search size={20} />
        Find Restaurants
      </button>
    </div>
  );
});

export default FindRestaurantsButton;
